import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router";
import './App.css';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import Layout from "./components/layout/Layout";
import Home from "./components/home/Home";
import ExperienceModal from "./components/home/experiences/ExperienceModal";
import foxData from "./components/home/experiences/data/FoxExperience";
import antologyData from "./components/home/experiences/data/AntologyExperience";
import chipotleData from "./components/home/experiences/data/ChipotleExperience";
import miraData from "./components/home/experiences/data/MiraExperience";
import qbciData from "./components/home/experiences/data/QBCIExperience";
import pomuData from "./components/home/experiences/data/PomuExperience";
import quickwashData from "./components/home/experiences/data/QuickWashExperience";

import SoftwareModal from "./components/home/software/SoftwareModal";
import eyeSpyData from "./components/home/software/data/EyeSpyProject";
import atradeData from "./components/home/software/data/ATradeProject";
import joyRideData from "./components/home/software/data/JoyRideProject";
import ezJobData from "./components/home/software/data/EzJobProject";
import azlonData from "./components/home/software/data/AzlonProject";
import discordData from "./components/home/software/data/DiscordProject";

import PaperModal from "./components/home/papers/PaperModal";
import ufcData from "./components/home/papers/data/UFCProject";
import cognitivePartnerData from "./components/home/papers/data/CognitivePartner";
import allostericPaperData from "./components/home/papers/data/AllostericPaper";
import allosteric2PaperData from "./components/home/papers/data/Allosteric2Paper";
import allosteric3PaperData from "./components/home/papers/data/Allosteric3Paper";
import spikeImmuneEscapePaperData from "./components/home/papers/data/SpikeImmuneEscapePaper";


import AboutModal from "./components/home/about/AboutModal";
import californiaData from "./components/home/about/data/CaliforniaStory";
import newYorkData from "./components/home/about/data/NewYorkStory";
import abroadData from "./components/home/about/data/AbroadStory";
import chessData from "./components/home/about/data/ChessStory";
import fishingData from "./components/home/about/data/FishingStory";
import startData from "./components/home/about/data/StartStory";

function AppContent() {
  const location = useLocation();
  const background = location.state?.background;

  return (
    <>
      <Routes location={background || location}>
        <Route path="*" element={<Home />} />
      </Routes>

      <Routes>
        <Route
          path="/experience/fox"
          element={<ExperienceModal experienceData={foxData} />}
        />
        <Route
          path="/experience/antology"
          element={<ExperienceModal experienceData={antologyData} />}
        />
        <Route
          path="/experience/chipotle"
          element={<ExperienceModal experienceData={chipotleData} />}
        />
        <Route
          path="/experience/mira"
          element={<ExperienceModal experienceData={miraData} />}
        />
        <Route
          path="/experience/qbci lab"
          element={<ExperienceModal experienceData={qbciData} />}
        />
        <Route
          path="/experience/pomu-io"
          element={<ExperienceModal experienceData={pomuData} />}
        />
        <Route
          path="/experience/quickwash"
          element={<ExperienceModal experienceData={quickwashData} />}
        />
        <Route
          path="/software/eyespy"
          element={<SoftwareModal projectData={eyeSpyData} />}
        />
        <Route
          path="/software/atrade"
          element={<SoftwareModal projectData={atradeData} />}
        />
        <Route
          path="/software/joyride"
          element={<SoftwareModal projectData={joyRideData} />}
        />
        <Route
          path="/software/ezjob"
          element={<SoftwareModal projectData={ezJobData} />}
        />
        <Route
          path="/software/azlon"
          element={<SoftwareModal projectData={azlonData} />}
        />
        <Route
          path="/software/discord-trading-bot"
          element={<SoftwareModal projectData={discordData} />}
        />
        <Route
          path="/paper/sars-cov-2-antibody-immune-escape"
          element={<PaperModal paperData={spikeImmuneEscapePaperData} />}
        />
        <Route
          path="/paper/decoding-allosteric-grammar-with-explainable-ai"
          element={<PaperModal paperData={allosteric3PaperData} />}
        />
        <Route
          path="/paper/ai-co-folding-models-for-allosteric-binding"
          element={<PaperModal paperData={allosteric2PaperData} />}
        />
        <Route
          path="/paper/predicting-and-decoding-allosteric-binding"
          element={<PaperModal paperData={allostericPaperData} />}
        />
        <Route
          path="/paper/predicting-allosteric-binding"
          element={<Navigate to="/paper/predicting-and-decoding-allosteric-binding" replace />}
        />
        <Route
          path="/paper/ufc-fight-prediction"
          element={<PaperModal paperData={ufcData} />}
        />
        <Route
          path="/paper/ai-as-a-cognitive-partner"
          element={<PaperModal paperData={cognitivePartnerData} />}
        />

        <Route
          path="/about/california"
          element={<AboutModal storyData={californiaData} />}
        />
        <Route
          path="/about/new-york"
          element={<AboutModal storyData={newYorkData} />}
        />
        <Route
          path="/about/abroad-2025"
          element={<AboutModal storyData={abroadData} />}
        />
        <Route
          path="/about/fishing"
          element={<AboutModal storyData={fishingData} />}
        />
        <Route
          path="/about/chess"
          element={<AboutModal storyData={chessData} />}
        />
        <Route
          path="/about/started"
          element={<AboutModal storyData={startData} />}
        />
        <Route path="*" element={null} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <Layout>
        <AppContent />
      </Layout>
      <SpeedInsights />
      <Analytics />
    </Router>
  );
}

export default App;
